import styled from "styled-components";
import { media } from "../../globalStyles";

export const ResetPassContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  height: auto;
  background-color: #0f1923ff;
  border: 4.5px solid #081019ff;
  ${media.mobile} {
    width: 90%;
  }
  ${media.tablet} {
    width: 80%;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 25px 0px;
  width: 100%;

  form {
    width: 100%;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  .resetButton {
    margin-top: 15px;
  }
  ${media.mobile} {
    align-items: flex-start !important;
    .resetButton {
      margin-left: 15px;
    }
  }
`;

export const InputContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
  gap: 30px;
  ${media.mobile} {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 10px;
    margin-left: 15px;
  }
`;

export const InputLabel = styled.h2`
  font-size: 15px !important;
  display: flex;
  justify-content: flex-end;
  font-weight: 300;
`;

export const Input = styled.input`
  width: 50%;
  background-color: whitesmoke;
  height: 30px;
  padding: 6px;
  border: none;
  font-style: italic;
  &:focus {
    outline-color: rgb(55, 72, 90);
    outline-style: solid;
    outline-width: 3px;
  }
  ${media.mobile} {
    width: 95%;
  }
  ${media.tablet} {
    width: 70%;
  }
`;
